module.exports = __webpack_public_path__ + "img/myposition_ss_앙투안 그리즈만.b68d4806.png";